<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 16C14 15.4477 14.4477 15 15 15H25C25.5523 15 26 15.4477 26 16C26 16.5523 25.5523 17 25 17H15C14.4477 17 14 16.5523 14 16ZM18 20C18 20.5523 18.4477 21 19 21H25C25.5523 21 26 20.5523 26 20C26 19.4477 25.5523 19 25 19H19C18.4477 19 18 19.4477 18 20ZM18 24C18 24.5523 18.4477 25 19 25H25C25.5523 25 26 24.5523 26 24C26 23.4477 25.5523 23 25 23H19C18.4477 23 18 23.4477 18 24Z"
      fill="#C2C6CD"
    />
    <path d="M15.5 16.5L15.5 24" stroke="#C2C6CD" stroke-linecap="round" />
    <line
      x1="18.5"
      y1="24"
      x2="15.5"
      y2="24"
      stroke="#C2C6CD"
      stroke-linecap="round"
    />
    <line x1="19" y1="20" x2="15" y2="20" stroke="#C2C6CD" />
    <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="#EBEEF5" />
  </svg>
</template>
